import React from 'react'
import FeatherIcon from 'feather-icons-react';
import {
} from 'utlis/AppMessages/AppMessages'
import { connect } from 'react-redux'

function IntegrationTopBar(props) {


    return (
        <div className="pad-12-B pad-25-T pad-25-L">
            <div className="d-flex justify-content-start multiplier-top-button">
                <div className="d-flex">
                    <div className="rt_item st-form form-sm mb-0 me-2">
                        <select
                            className="form-control"
                            placeholder="Action"
                            id="parentCategoryName">
                            <option value="">Most Popular</option>
                            <option value="">Most Popular</option>
                            <option value="">Most Popular</option>
                        </select>
                    </div>
                    <div className="rt_item st-form form-sm st-form-with-icon-right search mb-0 me-2">
                        <input type="text" className="form-control" placeholder="Search By Keywords" />

                        <div className="icon">
                            <FeatherIcon
                                icon="search"
                                size="16"
                                className="icon-main" />
                        </div>
                    </div>
                </div>
                <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0 me-2">
                    <button
                        type="button"
                        className="st-btn st-btn-sm border no-min-width st-btn-outline d-flex align-items-center justify-content-center"
                        onClick={() => { }}
                    >
                        <FeatherIcon
                            icon="eye"
                            size="14"
                            className="icon me-1" />
                        <span>Default View</span>
                    </button>
                </div>

                <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0 me-2">
                    <button
                        type="button"
                        className="st-btn st-btn-sm st-btn-gray no-min-width d-flex align-items-center justify-content-center "
                        onClick={() => { }}
                    >
                        <FeatherIcon
                            icon="filter"
                            size="14"
                            className="icon me-1" />
                        <span>Filter</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

export default connect(getDataFromStore, null)(IntegrationTopBar)